import React from 'react';
import cn from 'classnames';
import { ITabProps } from './Tabs.types';

// STYLES
import styles from '@UILayer/UILayer.scss';

export const Tab: React.FC<ITabProps> = ({ title, onPointerDown, isFocused }) => {
    const tabClassName: string = cn(styles.tab, { [styles.active]: isFocused });

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        onPointerDown(e);
    };

    return (
        <li className={tabClassName}>
            <button onPointerDown={handleClick}>{title}</button>
        </li>
    );
};
